import { render, staticRenderFns } from "./BlogRight.vue?vue&type=template&id=46398993"
import script from "./BlogRight.vue?vue&type=script&lang=js"
export * from "./BlogRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports